// extracted by mini-css-extract-plugin
export default {"task_page":"TaskPage_task_page__lUN9U","taskPage_section":"TaskPage_taskPage_section__izaId","task_text":"TaskPage_task_text__+Bs6A"};